import React, { /*useContext, useReducer*/ } from 'react';
import { Tab, Tabs, Container, Row, Col } from 'react-bootstrap';
import './Home.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import MessageList from '../MessageList/MessageList';
import MessageFilters from '../MessageFilters/MessageFilters';
import useMessages from '../../custom-hooks/useMessages';
import useFilters from '../../custom-hooks/useFilters';

const Home = () => {
  const [messages, getMessages, clearMessages, hideMessages, viewMessage, downloadMessages] = useMessages();
  const [filters, getFilters, setFilters, saveFilters, clearFilters] = useFilters();

  return (
    <div className="wrap">
      <div className="app">
      <Header />
      <Tabs defaultActiveKey="message_list" id="main-inbox-menu">
        <Tab eventKey="message_list" title="Inbox">
        <Container fluid className="HomeGrid">
          <Row>
            <Col className="HomeCol" sm={3}>
              <MessageFilters filters={filters} getMessages={getMessages} clearMessages={clearMessages} setFilters={setFilters} saveFilters={saveFilters} clearFilters={clearFilters} />
            </Col>
            <Col className="HomeCol">
                <MessageList className="custom-message-list" filters={filters} messages={messages} getMessages={getMessages} clearMessages={clearMessages} hideMessages={hideMessages} viewMessage={viewMessage} downloadMessages={downloadMessages}/>
            </Col>
          </Row>
        </Container>
        </Tab>
      </Tabs>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
